

import head from 'head.less';
import vendorCss from 'vendor.css';
import core from 'core.less';

import './general/js/matches-polyfill';
import responsiveImages from 'responsive-images/main';
import header from 'header/main';
import navTop from 'nav-top/main';
import navMain from 'nav-main/main';
import hero from 'hero/main';
import heroCarousel from 'hero-carousel/main';
import init from 'multi-selector/main';
import heroImage from 'hero-image/main';
import footer from 'footer/main';
import breadcrumbs from 'breadcrumbs/main';
import modal from 'modal/main';
import signposts from 'signposts/main';
import featuredContent from 'featured-content/main';
import imageGallery from 'image-gallery/main';
import waysToDonate from 'ways-to-donate/main';
import fileIcon from 'file-icon/main';
import textWithStatistic from 'text-with-statistic/main';
import statistic from 'statistic/main';
import pagination from 'pagination/main';
import relatedContent from 'related-content/main';
import forum from 'forum/main';
import socialLinks from 'social-links/main';
import buttonsGroup from 'buttons-group/main';
import showRule from 'show-rule/main';
import getInTouch from 'get-in-touch/main';
import fileInput from 'file-input/main';
import logoList from 'logo-list/main';
import centeredButton from 'centered-button/main';
import contentHeading from 'content-heading/main';
import gaTracker from 'ga-tracker/main';
import pageSpinner from 'page-spinner/main';
import helplineMenu from 'helpline-menu/main';
import donateMenu from 'donate-menu/main';

import textWithImage from 'text-with-image/main';
import promo from 'promo/main';
import video from 'video/main';

import accordion from 'accordion/main';
import map from 'map/main';
import lightbox from 'lightbox/main';
import tabs from 'tabs/main';
import form from 'form/main';
import staffContact from 'staff-contact/main';
import waysYouCanHelp from 'ways-you-can-help/main';
import touchButton from 'touch-button/main';
import hamburger from 'hamburger/main';
import profile from 'profile/main';
import listing from 'listing/main';
import filter from 'filter/main';
import rangePicker from 'rangepicker/main';
import datePicker from 'datepicker/main';
import justGiving from 'just-giving/main';
import jgTotal from 'jg-total/main';
import jgImagery from 'jg-imagery/main';
import jgDonations from 'jg-donations/main';
import jgLeaderboard from 'jg-leaderboard/main';
import spinner from 'spinner/main';
import currencySwitcher from 'currency-switcher/main';

import shop from 'shop/main';
import spinbox from 'spinbox/main';
import symptomChecker from 'symptom-checker/main';
import heroDonate from 'hero-donate/main';
import customDonate from 'custom-donate/main';
import searchtop from 'search-top/main';
import sharethis from 'sharethis/main';
import searchResults from 'search-results/main';
import downloads from 'downloads/main';
import moveTo from 'move-to/main';
import eligibilityChecker from 'eligibility-checker/main';
import cookieBar from 'cookie-bar/main';
import borderedBlock from 'bordered-block/main';
import loginBlock from 'login-block/main';
import donationSelector from 'donation-selector/main';
import paymentNav from 'payment-nav/main';
import fromContainer from 'form-container/main';
import tooltip from 'tooltip/main';
import paymentSummary from 'payment-summary/main';
import poolbutton from 'poll-button/main';
import embedProduct from 'embed-product/main';
import simpleList from 'simple-list/main';
import postbackButton from 'postback-button/main';
import giftAid from 'gift-aid/main';
import eventOptions from 'event-options/main';
import roundDonation from 'round-donation/main';
import account from 'account/main';

// load all grobal icons
const files = require.context('general/svg', true, /^\.\/.*\.svg/);
files.keys().forEach(files);



// WEBPACK FOOTER //
// ./app/app.js